import React from 'react';
import { motion } from 'framer-motion';
import { Trash2, CircleDollarSign, Clock, BookOpen } from 'lucide-react';
const problems = [{
  icon: Trash2,
  text: 'Cocinás mucho y terminás desperdiciando comida.'
}, {
  icon: CircleDollarSign,
  text: 'No sabés cuánto cobrar o te da miedo que nadie compre.'
}, {
  icon: Clock,
  text: 'Pasás horas en la cocina y no alcanzás a preparar todo.'
}, {
  icon: BookOpen,
  text: 'Te faltan ideas de recetas que rindan y gusten.'
}];
export const ProblemSection: React.FC = () => {
  return <section className="py-20 px-4 md:px-8 bg-brand-bg" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-primary mb-4" data-id="element-130">
            ¿Te pasa algo de esto?
          </h2>
          <div className="w-24 h-1 bg-brand-soft mx-auto rounded-full" data-id="element-131"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-132">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg shadow-brand-primary/5 flex items-start space-x-6 border border-brand-cream/50" data-id="element-133">
              <div className="flex-shrink-0 bg-red-50 p-4 rounded-full" data-id="element-134">
                <problem.icon className="w-8 h-8 text-red-500" data-id="element-135" />
              </div>
              <p className="text-lg text-brand-text-dark font-medium leading-relaxed pt-1" data-id="element-136">
                {problem.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};